// extracted by mini-css-extract-plugin
module.exports = {"container":"value-props_container__2ZoZJ","valueProp":"value-props_valueProp__CbUVu","valueProp--shrink":"value-props_valueProp--shrink__L05Q5"};